import { render } from "./TabDisplayCenter.vue?vue&type=template&id=51271e82"
import script from "./TabDisplayCenter.vue?vue&type=script&lang=js"
export * from "./TabDisplayCenter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__